
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 144 144","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M107.579 54c0-16.56-13.44-30-30-30-7.68 0-14.64 3-19.92 7.74l-8.58-8.58c7.5-6.9 17.46-11.16 28.5-11.16 23.22 0 42 18.78 42 42 0 9.42-3.78 20.16-9.06 30.66l-8.94-8.94c3.66-7.8 6-15.36 6-21.72zM68.221 42.36c2.58-2.1 5.82-3.36 9.36-3.36 8.28 0 15 6.72 15 15 0 3.54-1.26 6.78-3.36 9.36l-21-21zm-42.182-25.2l-8.46 8.46 19.08 19.08c-.66 3-1.08 6.12-1.08 9.3 0 31.5 42 78 42 78s10.02-11.1 20.28-26.1l20.1 20.1 8.46-8.46L26.039 17.16zm21.657 38.58c1.08 17.1 17.82 42.06 29.88 57.54 3.66-4.68 7.74-10.14 11.64-16.02l-41.52-41.52z"}})])
          )
        }
      }
    